"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_FULL_NAME = exports.MIN_FULL_NAME = exports.getFullNameError = exports.isValidFullName = exports.FULL_NAME_TRANSLATION_KEYS = void 0;
var MIN_FULL_NAME_LENGTH = 2;
var MAX_FULL_NAME_LENGTH = 250;
// Unicode-aware whitelist matching: Unicode letters (\p{L}, any script),
// marks (\p{M}, accents/diacritics), spaces (\p{Zs}), plus apostrophe, hyphen, period.
// Built via the RegExp constructor (not a literal) so the `u` flag and Unicode
// property escapes are not validated against the TS compile target (es5); both are
// supported at runtime by all evergreen browsers and Node.
var VALID_FULL_NAME_PATTERN = new RegExp('^[\\p{L}\\p{M}\\p{Zs}\u0027\\-.]+$', 'u');
var HAS_LETTER_PATTERN = new RegExp('\\p{L}', 'u');
exports.FULL_NAME_TRANSLATION_KEYS = {
    REQUIRED: 'FullNameRequired',
    TOO_SHORT: 'FullNameTooShort',
    NO_LETTER: 'FullNameNoLetter',
    INVALID: 'FullNameInvalid'
};
/**
 * Validates if a full name string is valid based on:
 * - Minimum length of 2 characters, ignoring surrounding whitespace (so 'a ' is invalid)
 * - Maximum length of 250 characters (raw, to guard against DB buffer overflows)
 * - Only allows Unicode letters, marks, spaces, hyphens, apostrophes, and periods
 * - Must contain at least one letter (rejects pure-punctuation like "--" or "..")
 */
var isValidFullName = function (fullName) {
    if (!fullName || fullName.length > MAX_FULL_NAME_LENGTH) {
        return false;
    }
    // Require at least MIN real (non-whitespace-padding) characters: rejects '', '  ', 'a ', ' a'.
    if (fullName.trim().length < MIN_FULL_NAME_LENGTH) {
        return false;
    }
    if (!HAS_LETTER_PATTERN.test(fullName)) {
        return false;
    }
    return VALID_FULL_NAME_PATTERN.test(fullName);
};
exports.isValidFullName = isValidFullName;
/**
 * Returns an appropriate error translation key based on validation failure
 * Returns empty string if full name is valid
 */
var getFullNameError = function (fullName) {
    var trimmedLength = fullName ? fullName.trim().length : 0;
    if (trimmedLength === 0) {
        return exports.FULL_NAME_TRANSLATION_KEYS.REQUIRED;
    }
    if (trimmedLength < MIN_FULL_NAME_LENGTH) {
        return exports.FULL_NAME_TRANSLATION_KEYS.TOO_SHORT;
    }
    if (fullName.length > MAX_FULL_NAME_LENGTH) {
        return exports.FULL_NAME_TRANSLATION_KEYS.INVALID;
    }
    if (!HAS_LETTER_PATTERN.test(fullName)) {
        return exports.FULL_NAME_TRANSLATION_KEYS.NO_LETTER;
    }
    if (!VALID_FULL_NAME_PATTERN.test(fullName)) {
        return exports.FULL_NAME_TRANSLATION_KEYS.INVALID;
    }
    return '';
};
exports.getFullNameError = getFullNameError;
exports.MIN_FULL_NAME = MIN_FULL_NAME_LENGTH;
exports.MAX_FULL_NAME = MAX_FULL_NAME_LENGTH;
